import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { CustomTicketsListState, StateWithTickets, TICKETS_FEATURE } from '../custom-tickets-state';

export const getTicketstListState: MemoizedSelector<StateWithTickets, any> = createFeatureSelector<CustomTicketsListState>(TICKETS_FEATURE);
